// extracted by mini-css-extract-plugin
module.exports = {"referral-activity":"Referral30Days_referral-activity__ytFCJ","salmon":"Referral30Days_salmon__DLFju","banner":"Referral30Days_banner__KKkey"};